import { render, staticRenderFns } from "./NoticeLogList.vue?vue&type=template&id=18f108ce"
import script from "./NoticeLogList.vue?vue&type=script&lang=js"
export * from "./NoticeLogList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports